
let OrbitControlsProxyExpoImplementation = function (___handlers) {
  const _handlers = ___handlers,
        OrbitControlsProxyInterface = require('../../../../interfaces/OrbitControlsProxyInterface');

  let that;

  class OrbitControlsProxyExpoImplementation extends OrbitControlsProxyInterface {

    constructor() {
      super();
      that = this;
      this.width = 0;
      this.height = 0;
    }

    setClientSize(width, height) {
      that.width = width;
      that.height = height;
    }

    getClientSize() {
      return {
        width: that.width, //_handlers.renderingHandler.getClientSize().width,
        height: that.height, //_handlers.renderingHandler.getClientSize().height,
      };
    }

    onStateChange() {

    }

    onStateChangeNone() {

    }

    dispose() {

    }

    initialize() {

    }

    onTouchesBegan(event) {
      that.onTouchStart(event);
    }

    onTouchesMoved(event) {
      that.onTouchMove(event);
    }

    onTouchesEnded(event) {
      that.onTouchEnd(event);
    }

  }

  return new OrbitControlsProxyExpoImplementation();
};

module.exports = OrbitControlsProxyExpoImplementation;
